var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "phone-oem"
  }, [_c("section", {
    staticClass: "phone-oem__banner-wrapper"
  }, [_c("Banner", {
    attrs: {
      title: "同花顺手机OEM",
      description: "\n        同花顺手机OEM拥有完整的产业链体系，包含行情、交易、商城、投顾、中台、指标运营、数据分析、AI智能、i问财等，\n        是一款集行情、交易、资讯等一站式终端投资理财平台。",
      productId: _vm.productId
    }
  })], 1), _c("section", {
    staticClass: "advantages"
  }, [_c("div", {
    staticClass: "advantages-main"
  }, [_c("Title", {
    attrs: {
      title: "产品优势"
    }
  }), _c("Advantages", {
    attrs: {
      leftItems: _vm.advantagesData.leftItems,
      rightItems: _vm.advantagesData.rightItems
    }
  })], 1)]), _c("section", {
    staticClass: "function"
  }, [_c("div", {
    staticClass: "function-main"
  }, [_c("Title", {
    attrs: {
      title: "功能介绍"
    }
  }), _c("section", {
    staticClass: "function__introduction"
  }), _c("section", {
    staticClass: "function-card"
  }, [_c("FunctionCard", {
    attrs: {
      list: _vm.functionCardData
    }
  }), _vm.functionCardData.length % 3 !== 0 ? _c("span", {
    staticStyle: {
      width: "411px"
    }
  }) : _vm._e()], 1)], 1)]), _c("Appointment2")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };